export const LOCK_POLL_INTERVAL_MS = 5000;
const LOCK_POLL_HALTED_MESSAGE = "Lock status is out of date. Reload or revisit this page to see who is reviewing.";
/**
 * A per-mount latch reporting once through the caller's own error ref. One-way: a server that
 * rejects the poll or answers something other than a projection answers the same next tick.
 */
export function createLockPollHalt(error) {
    let halted = false;
    return {
        isHalted: () => halted,
        halt: () => {
            halted = true;
            error.value = LOCK_POLL_HALTED_MESSAGE;
        },
    };
}
